import session from './session';

export default {
    getDistrictList(filter) {
        return session.get(`address/district/${filter}`);
    },
};
